import { useAllSessions, useAdminRevokeSession } from '../../hooks/useSessions.js';
import { useError } from '../../components/shared/ErrorBanner.jsx';

// Shows every active session in the org. Useful for revoking a session
// after a phone is lost or a credential leak. Admin-only by AdminLayout
// gating, but the server endpoint also enforces admin.
export default function SessionsPage() {
  const { data: sessions = [], refetch } = useAllSessions();
  const revoke = useAdminRevokeSession();
  const { show } = useError();

  const onRevoke = async (s) => {
    if (!confirm(`Revoke session for ${s.user_name}? They'll be signed out on next request.`)) return;
    try {
      await revoke.mutateAsync(s.token);
    } catch (err) { show(err.message); }
  };

  return (
    <div>
      <div className="range-bar">
        <span style={{ color: 'var(--warm-gray)', fontSize: 12 }}>
          {sessions.length} active session{sessions.length === 1 ? '' : 's'}
        </span>
        <button className="btn-sm" onClick={() => refetch()}>Refresh</button>
      </div>
      {sessions.length === 0 ? (
        <div className="loading">No active sessions.</div>
      ) : (
        <table className="tbl">
          <thead>
            <tr>
              <th>User</th>
              <th className="col-meta">Started</th>
              <th>Expires</th>
              <th className="col-meta">IP</th>
              <th className="col-meta">Device</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {sessions.map(s => (
              <tr key={s.token}>
                <td>{s.user_name}</td>
                <td className="col-meta">{new Date(s.created_at).toLocaleString()}</td>
                <td>{new Date(s.expires_at).toLocaleDateString()}</td>
                <td className="col-meta" style={{ fontFamily: 'ui-monospace, monospace', fontSize: 11 }}>{s.ip || '—'}</td>
                <td className="col-meta" style={{ maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', fontSize: 11, color: 'var(--warm-gray)' }}>
                  {s.user_agent || '—'}
                </td>
                <td style={{ textAlign: 'right' }}>
                  <button className="btn-sm" onClick={() => onRevoke(s)} disabled={revoke.isPending}>
                    Revoke
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
